(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function formatStockholmTime() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Europe/Stockholm'
      }).formatToParts(new Date());

      var hour = '00';
      var minute = '00';
      parts.forEach(function (part) {
        if (part.type === 'hour') { hour = part.value; }
        if (part.type === 'minute') { minute = part.value; }
      });

      if (hour === '24') { hour = '00'; }

      return hour + ':' + minute;
    } catch (e) {
      return '--:--';
    }
  }

  // DD/MM/YYYY, Stockholm timezone -- built from formatToParts rather
  // than trusting a locale's own punctuation/ordering, same reasoning
  // as formatStockholmTime above.
  function formatStockholmDate() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'Europe/Stockholm'
      }).formatToParts(new Date());

      var day = '--';
      var month = '--';
      var year = '----';
      parts.forEach(function (part) {
        if (part.type === 'day') { day = part.value; }
        if (part.type === 'month') { month = part.value; }
        if (part.type === 'year') { year = part.value; }
      });

      return day + '/' + month + '/' + year;
    } catch (e) {
      return '--/--/----';
    }
  }

  function updateClocks() {
    var timeValue = formatStockholmTime();
    var dateValue = formatStockholmDate();

    document.querySelectorAll('[data-header-clock-value]').forEach(function (el) {
      el.textContent = timeValue;
    });
    document.querySelectorAll('[data-header-date-value]').forEach(function (el) {
      el.textContent = dateValue;
    });
  }

  ready(function () {
    if (!document.querySelector('[data-header-clock-value]')) { return; }

    updateClocks();

    var msIntoMinute = new Date().getSeconds() * 1000 + new Date().getMilliseconds();
    var msUntilNextMinute = 60000 - msIntoMinute;

    setTimeout(function () {
      updateClocks();
      setInterval(updateClocks, 60000);
    }, msUntilNextMinute);
  });
})();
